export default {
  nav: {
    Down: "ดาวน์โหลดเลย",
    ReserveGift: "นัดรับรางวัล",
    CharacterIntroduction: "แนะนำตัวละคร",
    Gameplay: "แนะนำเกม",
    AttentionFB: "โปรฯเติมเงิน",
  },
  news: {
    NextPage: "ถัดไป",
    PrevPage: "ก่อนหน้า",
    NextContent: "บทความถัดไป",
    PrevContent: "บทความก่อนหน้า",
    Return: "ย้อนกลับ",
    ReturnList: "กลับสู่รายการ",
    More: "เพิ่มเติม",
    None: "ไม่มีแล้ว",
  },
};
